import {gql} from '@apollo/client';
import {CustomerComplaint} from '../types/CustomerComplaintType';

/** 客诉全量列表（不分页，后端硬上限 2000）；dspId / warehouseId 等筛选维度均放入 filter */
export const GET_CUSTOMER_COMPLAINT_LIST_BY_FILTERS = gql`
    query GetCustomerComplaintListByFilters($filter: CustomerComplaintListFilterInput) {
        getCustomerComplaintListByFilters(filter: $filter) {
            id
            complaintType
            trackingNumber
            orderOverallStatus
            status
            appealDeadlineAt
            appealSubmittedAt
            finishedAt
        }
    }
`;

export interface CustomerComplaintListFilterInput {
    /** DSP ID；mobile DSP 视角必传 */
    dspId?: number;
    /** 仓库 ID；全场景必传，与索引最左前缀对齐 */
    warehouseId: number;
    statusList?: string[];
    /** 完结态过滤：undefined=不限，0=仅未完结(待处理/申诉中)，1=仅已完结(历史)；与后端 is_finished 复合索引对齐 */
    isFinished?: number;
    /** 多个运单号以 ; , 换行 分隔的原始字符串 */
    trackingNumbers?: string;
    driverId?: number;
    complaintType?: string;
    /** 客诉发起渠道（EMAIL/PHONE/OTHER）；多值 IN 查询，单值场景传 1 元素列表即可 */
    sourceList?: string[];
    /** ISO-8601；按 created_at 过滤（下发时间） */
    createdAtFrom?: string;
    createdAtTo?: string;
    /** ISO-8601；按 customer_complaint_review.appeal_submitted_at 过滤 */
    appealSubmittedAtFrom?: string;
    appealSubmittedAtTo?: string;
    /** ISO-8601；按 finished_at 过滤（完结时间） */
    finishedAtFrom?: string;
    finishedAtTo?: string;
    /** 排序字段：APPEAL_DEADLINE_AT（默认）/FINISHED_AT/CREATED_AT */
    sortBy?: 'APPEAL_DEADLINE_AT' | 'FINISHED_AT' | 'CREATED_AT';
    /** 排序方向：ASC / DESC */
    sortDirection?: 'ASC' | 'DESC';
}

export interface GetCustomerComplaintListByFiltersResponse {
    getCustomerComplaintListByFilters: CustomerComplaint[];
}

export interface GetCustomerComplaintListByFiltersVariables {
    filter?: CustomerComplaintListFilterInput;
}
